/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyBgp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.975 21A4.947 4.947 0 0 0 11 18v-5h3v-2h-3V6c0-1.654 1.346-3 3-3 .861 0 1.681.37 2.251 1.016l1.5-1.323A5.003 5.003 0 0 0 14 1c-2.757 0-5 2.243-5 5v5H6v2h3v5c0 1.654-1.345 3-3 3v2h12v-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyBgp as CurrencyBgp };
